import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { outageStatusSelector } from "../../selectors/settingsSelectors";

import "./OutageBanner.scss";

const formatMessage = ({ info_url, info_url_text, message }) => {
  if (!info_url) {
    return message;
  }

  const re = /(^.*)(\$info_url)(.*$)/;
  const result = message.match(re);

  if (!result) {
    return message;
  }

  const [, msg1 = "", , msg2 = ""] = result;

  const newMessage = (
    <div>
      {msg1}

      <a href={info_url} rel="noopener noreferrer" target="_blank">
        {info_url_text}
      </a>

      {msg2}
    </div>
  );

  return newMessage;
};

const OutageBanner = (props) => {
  const { enabled, info_url, info_url_text, message } = props;

  if (!enabled) {
    return null;
  }

  const displayMsg = formatMessage({
    info_url,
    info_url_text,
    message,
  });

  return <div className="outage-banner">{displayMsg}</div>;
};

OutageBanner.propTypes = {
  enabled: PropTypes.bool.isRequired,
  info_url: PropTypes.string.isRequired,
  info_url_text: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const outageStatus = outageStatusSelector(state);

  return outageStatus;
};

export default connect(mapStateToProps, null)(OutageBanner);
